import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function EnquiryThankYouPage() {
  const { state } = useLocation();
  const enquiryNumber = state?.enquiryNumber;

  return (
    <div className="card thank-you-card">
      <h2>Thank you!</h2>
      <p>Your enquiry has been submitted successfully.</p>
      {enquiryNumber && (
        <p className="enquiry-number">
          Your enquiry number: <strong>{enquiryNumber}</strong>
        </p>
      )}
      <p className="muted">
        Our counseling team will contact you shortly. Please save your enquiry number
        for future reference.
      </p>
      <Link to="/enquiry" className="btn btn-primary">
        Submit another enquiry
      </Link>
    </div>
  );
}
